<template>
    <AdaptersDialog
        :listener-id="listenerOpen"
        :header="$t('lang.wordstat.update_project.header')"
        :loading="loading"
        :callback-agree="update"
        ref="popup"
    >
        <template #content>
            <div class="grid">
                <div class="col-12" v-if="model.title">
                    <span
                        class="text-sm text-color-secondary mt-0 pt-0 pb-2 mb-2"
                        v-html="$t('lang.wordstat.update_project.text', [model.title])"
                    ></span>
                </div>
                <div class="col-12">
                    <div class="field mb-0">
                        <label class="required">{{ $t('lang.wordstat.update_project.label_frequency') }}</label>
                        <div class="formgroup-inline">
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WS]" binary inputId="frequency-ws" />
                                <label for="frequency-ws">{{ $t('lang.wordstat.update_project.frequency_ws') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_QWSK]" binary inputId="frequency-qwsk" />
                                <label for="frequency-qwsk">{{ $t('lang.wordstat.update_project.frequency_qwsk') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WSK]" binary inputId="frequency-wsk" />
                                <label for="frequency-wsk">{{ $t('lang.wordstat.update_project.frequency_wsk') }}</label>
                            </div>
                            <!--
                            TODO: временно закоментировано, расскоментировать переходе на получение частотки из бюджетов
                            <div v-if="model.source === ProjectsConstants.SOURCE_WS" class="field-checkbox">
                                <Checkbox
                                    v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_SWSK]"
                                    binary
                                    inputId="frequency-swsk"
                                />
                                <label for="frequency-swsk">{{ $t('lang.wordstat.update_project.frequency_swsk') }}</label>
                            </div>
                            <div v-else-if="model.source === ProjectsConstants.SOURCE_DIRECT" class="field-checkbox p-disabled">

                                <Checkbox binary inputId="frequency-swsk" :value="false" />
                                <label for="frequency-swsk">{{ $t('lang.wordstat.update_project.frequency_swsk') }}</label>
                            </div> -->
                            <div class="field-checkbox">
                                <Checkbox v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_SWSK]" binary inputId="frequency-swsk" />
                                <label for="frequency-swsk">{{ $t('lang.wordstat.update_project.frequency_swsk') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox v-model="model.parse_budget_cpc" binary inputId="parse-budget-cpc" />
                                <label for="parse-budget-cpc">{{ $t('lang.wordstat.update_project.parse_budget_cpc') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-content-between align-items-center w-full">
                <TemplatesLimits :limits="getCountLimits" />
                <div class="flex gap-2">
                    <Button :label="$t('lang.wordstat.update_project.button_save')" @click="update" :disabled="isDisableSend" />
                    <Button :label="$t('lang.wordstat.update_project.button_close')" @click="onClose" class="p-button-text" />
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import AdaptersDialog from "keysso/component/adapters/Dialog.vue";
import Alerts from "keysso/mixins/Alerts";
import TemplatesLimits from "keysso/templates/Limits.vue";
import {ProjectsConstants} from "../constants/projectConstants";

/**
 * Базовый компонент для попап обновления.
 * Обязательные методы для дочерних компонентов:
 * @method getListenerId() - ID слушателя
 * @method update() - обработчик обновления
 */
export default {
    name: "WordstatBaseUpdate",
    emits: ['onAgree'],
    mixins: [Alerts],
    data() {
        return {
            loading: false,
            listenerOpen: this.getListenerId(),
            model: {
                id: null,
                title: null,
                source: null,
                wordsCount: null,
                words: null,
                frequency: {
                    [ProjectsConstants.FREQUENCY_TYPE_WS]: true,
                    [ProjectsConstants.FREQUENCY_TYPE_QWSK]: false,
                    [ProjectsConstants.FREQUENCY_TYPE_WSK]: false,
                    [ProjectsConstants.FREQUENCY_TYPE_SWSK]: false,
                },
                parse_budget_cpc: false,
            },
        };
    },
    mounted() {
        this.$emitter.on(this.getListenerId(), (data) => {
            this.model = Object.assign({}, this.model, data);
        });
    },
    computed: {
        ProjectsConstants() {
            return ProjectsConstants;
        },
        getCountLimits() {
            const frequencyCount = Object
                .keys(this.model.frequency)
                .filter(key => this.model.frequency[key])
                .length;

            let countLimits = this.model.wordsCount * frequencyCount;
            if (this.model.parse_budget_cpc) {
                countLimits += this.model.wordsCount;
            }

            return countLimits;
        },
        isDisableSend() {
            return this.getCountLimits < 1;
        },
    },
    methods: {
        onClose() {
            this.$refs.popup.onClose();
        },
        /**
         * Изменяется только эти значения
         */
        getListenerId() {},
        update() {},
    },
    components: {
        RadioButton,
        Checkbox,
        Button,
        AdaptersDialog,
        TemplatesLimits,
    }
}
</script>
